import { UserProfile } from '@totem/types/user';
import { isNotNull } from '@totem/utilities/common';

import accountUtilities from '../components/userContext/accountUtilities';

// let currentUserRole = null; // Role Name
// let currentUserRoleLevel = null;  // Role Number

// const setUserRole = (roleId) => {
//   return (currentUserRole = accountUtilities.getRoleString(roleId));
// };
//
// const setUserRoleLevel = (roleId) => {
//   return (currentUserRoleLevel = roleId);
// };

/**
 * ASSIGNED_VENDOR_ROLE represents the value that belongs to
 * the assigned vendor role.  This isn't a user that belongs
 * to a vendor organization type, instead they are a different
 * role altogether from a ReadOnly, Team Member, etc user which
 * begins the enumeration at 0.
 */
const ASSIGNED_VENDOR_ROLE = -1;
const ASSIGNED_TENANT_ROLE = -2;

/**
 * ROLES
 * To add a new role insert it below roles that have a higher permission.
 * Update the role immediately below to inherit properly.
 * Add the new role to the available ROLE_SETS.
 * Ex.
 */
const SYSTEMS_ADMIN_ROLE = 'Systems Administrator';
const ADMIN_ROLE = 'Admin';
const TEAM_MEMBER_ROLE = 'Team Member';
const COLLABORATOR_ROLE = 'Collaborator';
const VENDOR_ROLE = 'Vendor';
const TENANT_ROLE = 'Tenant';

const SYSTEMS_ADMINISTRATOR = [SYSTEMS_ADMIN_ROLE];
const ORGANIZATION_ADMINISTRATOR = [...SYSTEMS_ADMINISTRATOR, ADMIN_ROLE];
const TEAM_MEMBER = [...ORGANIZATION_ADMINISTRATOR, TEAM_MEMBER_ROLE];
const COLLABORATOR = [...TEAM_MEMBER, COLLABORATOR_ROLE];
const VENDOR = [...COLLABORATOR, VENDOR_ROLE];
const TENANT = [...VENDOR_ROLE, TENANT_ROLE];

export const ROLE_SETS = {
  SYSTEMS_ADMINISTRATOR,
  ORGANIZATION_ADMINISTRATOR,
  TEAM_MEMBER,
  COLLABORATOR,
  VENDOR,
  TENANT,
};

export const minimumRequiredRole = (userProfile: UserProfile, roleSet) => {
  let role = 0;
  if (isNotNull(userProfile) && isNotNull(userProfile.organization)) {
    role = userProfile.organization.role;
  }
  const currentUserRole = accountUtilities.getRoleString(role);
  return roleSet.includes(currentUserRole);
};

export const isVendorUser = (userProfile: UserProfile) => {
  if (isNotNull(userProfile) && isNotNull(userProfile.organization)) {
    return userProfile.organization.role === ASSIGNED_VENDOR_ROLE;
  }
  return false;
};

export const isTenantUser = (userProfile: UserProfile) => {
  if (isNotNull(userProfile) && isNotNull(userProfile.organization)) {
    return userProfile.organization.role === ASSIGNED_TENANT_ROLE;
  }

  return false;
};

export const getDashboardPath = (userProfile: UserProfile) => {
  return isTenantUser(userProfile)
    ? '/tenant-dashboard'
    : isVendorUser(userProfile)
      ? '/vendor-dashboard'
      : '/dashboard';
};

export default {
  ASSIGNED_VENDOR_ROLE,
  ROLE_SETS,
  minimumRequiredRole,
  isVendorUser,
  isTenantUser,
  getDashboardPath,
};
